import produce from "immer";
import { ObjectType } from "../interfaces/object";
import { LineStyle } from "../interfaces/element";
export const createObject = (objects, graphId, setSelected) => {
    const defaultObject = {
        graphId: graphId,
        title: "",
        fillObject: false,
        color: "#FF0000",
        lineWidth: 1,
        lineStyle: LineStyle.solid,
        type: ObjectType.horizon,
        file: null,
        colX: null,
        coordsString: "0",
        coords: [0],
        text: "",
    };
    const updatedContent = produce(objects, (draft) => {
        draft.push(defaultObject);
    });
    setSelected(objects.length);
    return updatedContent;
};
export const deleteObject = (objects, indexToDelete) => {
    const updatedContent = produce(objects, (draft) => {
        draft.splice(indexToDelete, 1);
    });
    return updatedContent;
};
//# sourceMappingURL=object.js.map